import React from 'react';

export default function LoadingSpinner({
  size = 'md',
  className = '',
}) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  return (
    <svg
      className={`animate-spin ${sizes[size]} text-prism-cyan ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

// Full page loading screen
export function LoadingScreen({ message = 'Loading...' }) {
  return (
    <div className="fixed inset-0 bg-prism-dark flex flex-col items-center justify-center z-50">
      <LoadingSpinner size="xl" />
      <p className="mt-4 text-prism-text-secondary">{message}</p>
    </div>
  );
}

// Skeleton loading placeholder
export function Skeleton({ className = '', variant = 'rect' }) {
  const baseStyles = 'bg-prism-card animate-pulse';

  const variants = {
    rect: 'rounded-lg',
    circle: 'rounded-full',
    text: 'rounded h-4',
  };

  return <div className={`${baseStyles} ${variants[variant]} ${className}`} />;
}
